import { useMutation, useQueryClient } from '@tanstack/react-query';
import { JobPeriod } from '@thro-types/jobmarket';

import { AxiosRequestConfig } from 'axios';

import { deactivateJobPeriod, deleteJobPeriod } from 'api/jobmarketService';

export const useJobPeriodMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();

  const deletion = useMutation<JobPeriod, Error, number>({
    mutationFn: async args => {
      return await deleteJobPeriod(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['jobOfferings', data.offerId] });
    },
    onError: data => {}
  });

  const deactivate = useMutation<JobPeriod, Error, { jobPeriodIds: number[] }>({
    mutationFn: async args => {
      return await deactivateJobPeriod(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['jobOfferings'] });
    },
    onError: data => {}
  });

  return { deletion, deactivate } as const;
};
